import React, { useState, useEffect } from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { motion } from 'framer-motion';
import GavelIcon from '@mui/icons-material/Gavel';
import LockIcon from '@mui/icons-material/Lock';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { useTranslation } from 'react-i18next';

const ChainOfCustodyVisual = () => {
    const { t } = useTranslation();
    // VETRA_AI_IGNORE_NEXT
    const finalHash = "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855";
    const [displayHash, setDisplayHash] = useState(t('industryApplications.animations.chainOfCustody.scanning'));

    useEffect(() => {
        const timer = setTimeout(() => {
            setDisplayHash(finalHash);
        }, 2000); 
        return () => clearTimeout(timer);
    }, []);

    return (
        <Box sx={{ 
            width: '100%', height: '100%', minHeight: '300px', display: 'flex', flexDirection: 'column',
            backgroundColor: 'rgba(0,0,0,0.4)', borderRadius: 2, border: '1px solid rgba(255, 255, 255, 0.1)', p: 3
        }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
                <GavelIcon sx={{ color: 'var(--secondary-color)' }} />
                <Typography sx={{ fontWeight: 800, color: 'white', letterSpacing: '0.5px' }}>
                    {t('industryApplications.animations.chainOfCustody.header')}
                </Typography>
            </Box>
            
            <Divider sx={{ borderColor: 'rgba(255,255,255,0.1)', mb: 3 }} />

            <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                <Box sx={{ p: 2, backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: 2, display: 'flex', alignItems: 'center' }}>
                    <InsertDriveFileIcon sx={{ fontSize: 40, color: '#94a3b8' }} />
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <Typography sx={{ fontSize: '0.75rem', color: '#94a3b8', textTransform: 'uppercase', fontWeight: 700 }}>
                        {t('industryApplications.animations.chainOfCustody.fileNameLabel')}
                    </Typography>
                    <Typography sx={{ color: 'white', fontFamily: 'monospace', fontSize: '1.1rem' }}>
                        {t('industryApplications.animations.chainOfCustody.fileNameValue')}
                    </Typography>
                </Box>
            </Box>

            <Box sx={{ mb: 3, p: 2, backgroundColor: 'rgba(0,0,0,0.3)', borderRadius: 2, borderLeft: '3px solid var(--secondary-color)' }}>
                <Typography sx={{ fontSize: '0.75rem', color: 'var(--secondary-color)', textTransform: 'uppercase', fontWeight: 700, mb: 0.5 }}>
                    {t('industryApplications.animations.chainOfCustody.hashLabel')}
                </Typography>
                <Typography sx={{ 
                    color: displayHash === finalHash ? '#4caf50' : '#e2e8f0', 
                    fontFamily: 'monospace', fontSize: '0.9rem', wordBreak: 'break-all', transition: 'color 0.3s ease'
                }}>
                    {displayHash}
                </Typography>
            </Box>

            <Box sx={{ mt: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: 'rgba(76, 175, 80, 0.1)', p: 2, borderRadius: 2, border: '1px solid rgba(76, 175, 80, 0.3)' }}>
                <Box>
                    <Typography sx={{ fontSize: '0.75rem', color: '#4caf50', textTransform: 'uppercase', fontWeight: 700 }}>
                        {t('industryApplications.animations.chainOfCustody.ledgerStatusLabel')}
                    </Typography>
                    <Typography sx={{ color: 'white', fontSize: '0.85rem' }}>
                        {t('industryApplications.animations.chainOfCustody.ledgerStatusValue')}
                    </Typography>
                </Box>
                <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 2.2, type: 'spring' }}>
                    <LockIcon sx={{ color: '#4caf50', fontSize: 32 }} />
                </motion.div>
            </Box>
        </Box>
    );
};

export default ChainOfCustodyVisual;